import { Button, Card, Panel } from '@/components/Bicester';
import { Form } from '@/components/formik-rsuite';
import { useRequest } from 'ahooks';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import React from 'react';
import { defaultThirdInfo, thirdSchema } from './constants';
import { SiteContext } from '..';
import Toolbar from '../components/Toolbar';
import { LEVEL_TYPE } from '@/constants';
import { Alert } from 'rsuite';
import { push } from '@/utils/history';
import { fetchAddEditThird } from '@/services/site/third';
import useExchangePlatform from '@/hooks/preload/useExchangePlatform';
import PageLoader from '@/components/shared/PageLoader';
import useLoading from '@/hooks/useLoading';
import useSiteBrandList from '@/hooks/preload/useSiteBrandList';
import { IconButton } from 'rsuite5';
import Image from '@/components/Bicester/Image';
import { add } from '@/utils/calculate';

const Third = () => {
  const { member } = React.useContext(SiteContext);
  const { data: brandList, loading: brandListLoading } = useSiteBrandList();
  const { data: exchangePlatform, loading: exchangePlatformLoading } = useExchangePlatform();

  const { run: addEditThird, loading: addEditThirdLoading } = useRequest(fetchAddEditThird, {
    manual: true,
  });

  const formik = useFormik({
    initialValues: defaultThirdInfo,
    validationSchema: thirdSchema,
    onSubmit(values, actions) {
      const data = Object.assign({}, values, {
        externalgift_items: JSON.stringify(values.externalgift_items),
        [member?.level === LEVEL_TYPE.NOT ? 'not_member_id' : 'member_id']: member?.id,
      });
      addEditThird(data)
        .then((res) => {
          if (res?.id) {
            const { id } = res;
            Alert.success(res?.msg ?? '保存成功');
            push(`/site-service/record/info/third/${id}`);
          }
        })
        .catch((e) => {
          actions.setErrors(e.formError);
        });
    },
  });

  const loading = useLoading(brandListLoading || exchangePlatformLoading);

  return (
    <FormikProvider value={formik}>
      {loading && <PageLoader />}
      <Form guard>
        <Panel
          leftShadow
          style={{
            minHeight:
              'calc(100vh - var(--headerHeight) - var(--navBarHeight) - var(--toolBarHeight) - 195px)',
          }}
          loading={addEditThirdLoading}
        >
          <Card smDivider>
            <FieldArray name="externalgift_items">
              {({ insert, remove, push }) => (
                <>
                  <Toolbar
                    title="第三方积分登记"
                    handleAdd={() => push({ pos_no: '', money: '', brand: '' })}
                    handleReset={formik.resetForm}
                  />
                  <div className="flex w-[75%]">
                    <Card.Picker
                      required
                      label="兑换平台"
                      formKey="externalgift_act_id"
                      pickerData={exchangePlatform}
                      searchable
                      placement="topStart"
                    />
                    <Card.Input required label="第三方兑换卡号" formKey="card_no" />
                    <Card.Input
                      notEditable
                      label="总金额"
                      inputType="price"
                      formKey="totalMoney"
                      defaultValue={0}
                      value={
                        formik.values.externalgift_items
                          ?.map((item) => item?.money)
                          ?.reduce((a, b) => add(a, b), 0) || 0
                      }
                    />
                  </div>
                  <div className="w-[75%]">
                    {formik.values.externalgift_items.length > 0 &&
                      formik.values.externalgift_items.map((item, index) => (
                        <div className="flex" key={index}>
                          <div className="flex-1 relative">
                            <Card.Picker
                              required
                              label="品牌"
                              formKey={`externalgift_items.${index}.brand`}
                              pickerData={brandList}
                              searchable
                              placement="topStart"
                            />
                            <IconButton
                              className={`w-[17px] h-[17px] ml-[5px] ${
                                index === 0 && formik.values.externalgift_items.length <= 1
                                  ? 'invisible'
                                  : ''
                              }`}
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: -22,
                                height: 47,
                                zIndex: 1,
                              }}
                              onClick={() => remove(index)}
                            >
                              <Image src="/resources/images/delete.svg" />
                            </IconButton>
                          </div>
                          <Card.Input
                            required
                            label="小票编号"
                            formKey={`externalgift_items.${index}.pos_no`}
                          />
                          <Card.Input
                            required
                            label="金额"
                            inputType="number"
                            formKey={`externalgift_items.${index}.money`}
                          />
                        </div>
                      ))}
                  </div>
                </>
              )}
            </FieldArray>
          </Card>
          <div className="flex justify-end mt-[20px]">
            <Button type="submit" className="px-[70px]">
              确认提交
            </Button>
          </div>
        </Panel>
      </Form>
    </FormikProvider>
  );
};

export default Third;
